import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  questionsTab: number;
}

const initialState: AuthState = {
  questionsTab: 1,
};

const questionsTabSlice = createSlice({
  name: 'navigateQuestionsTab',
  initialState,
  reducers: {
    questionCurrentTab: (state, action: PayloadAction<number>) => {
      state.questionsTab = action.payload;
    },
    clearCurrentTab: state => {
      state.questionsTab = 1;
    },
  },
});

export const { questionCurrentTab, clearCurrentTab } = questionsTabSlice.actions;
export default questionsTabSlice.reducer;
